import { render, staticRenderFns } from "./ApplicationsGrid.vue?vue&type=template&id=1c60d549"
import script from "./ApplicationsGrid.vue?vue&type=script&lang=js"
export * from "./ApplicationsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports